import React from 'react';

function WordIconSVG({ width = '558', height = '741' }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 558 741'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='481' height='687' rx='28' fill='#725EEE' />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M79 35C56.3563 35 38 53.3563 38 76V700C38 722.644 56.3563 741 79 741H496C518.644 741 537 722.644 537 700V148H424V35H79Z'
                fill='#F4F4F4'
            />
            <g filter='url(#filter0_d_90_87)'>
                <path d='M424 35L478.5 90L537 148H424V35Z' fill='#FEFEFE' />
            </g>
            <rect
                x='276'
                y='537'
                width='282'
                height='92'
                rx='19'
                fill='#725EEE'
            />
            <path
                d='M321.088 605.512C319.168 605.512 317.589 604.957 316.352 603.848C315.157 602.696 314.56 601.288 314.56 599.624C314.56 597.917 315.157 596.488 316.352 595.336C317.589 594.184 319.168 593.608 321.088 593.608C322.965 593.608 324.501 594.184 325.696 595.336C326.933 596.488 327.552 597.917 327.552 599.624C327.552 601.288 326.933 602.696 325.696 603.848C324.501 604.957 322.965 605.512 321.088 605.512ZM350.863 560.072C355.599 560.072 359.737 561.011 363.279 562.888C366.82 564.765 369.551 567.411 371.471 570.824C373.433 574.195 374.415 578.099 374.415 582.536C374.415 586.931 373.433 590.835 371.471 594.248C369.551 597.661 366.799 600.307 363.215 602.184C359.673 604.061 355.556 605 350.863 605H334.031V560.072H350.863ZM350.159 595.528C354.297 595.528 357.519 594.397 359.823 592.136C362.127 589.875 363.279 586.675 363.279 582.536C363.279 578.397 362.127 575.176 359.823 572.872C357.519 570.568 354.297 569.416 350.159 569.416H344.975V595.528H350.159ZM401.779 605.448C397.555 605.448 393.672 604.467 390.131 602.504C386.632 600.541 383.837 597.811 381.747 594.312C379.698 590.771 378.674 586.803 378.674 582.408C378.674 578.013 379.698 574.067 381.747 570.568C383.837 567.069 386.632 564.339 390.131 562.376C393.672 560.413 397.555 559.432 401.779 559.432C406.003 559.432 409.864 560.413 413.363 562.376C416.904 564.339 419.677 567.069 421.683 570.568C423.731 574.067 424.755 578.013 424.755 582.408C424.755 586.803 423.731 590.771 421.683 594.312C419.635 597.811 416.861 600.541 413.363 602.504C409.864 604.467 406.003 605.448 401.779 605.448ZM401.779 595.464C405.363 595.464 408.221 594.269 410.354 591.88C412.531 589.491 413.619 586.333 413.619 582.408C413.619 578.44 412.531 575.283 410.354 572.936C408.221 570.547 405.363 569.352 401.779 569.352C398.152 569.352 395.251 570.525 393.075 572.872C390.941 575.219 389.875 578.397 389.875 582.408C389.875 586.376 390.941 589.555 393.075 591.944C395.251 594.291 398.152 595.464 401.779 595.464ZM428.987 582.472C428.987 578.035 429.947 574.088 431.867 570.632C433.787 567.133 436.454 564.424 439.867 562.504C443.323 560.541 447.227 559.56 451.579 559.56C456.912 559.56 461.478 560.968 465.275 563.784C469.072 566.6 471.611 570.44 472.891 575.304H460.859C459.963 573.427 458.683 571.997 457.019 571.016C455.398 570.035 453.542 569.544 451.451 569.544C448.08 569.544 445.35 570.717 443.259 573.064C441.168 575.411 440.123 578.547 440.123 582.472C440.123 586.397 441.168 589.533 443.259 591.88C445.35 594.227 448.08 595.4 451.451 595.4C453.542 595.4 455.398 594.909 457.019 593.928C458.683 592.947 459.963 591.517 460.859 589.64H472.891C471.611 594.504 469.072 598.344 465.275 601.16C461.478 603.933 456.912 605.32 451.579 605.32C447.227 605.32 443.323 604.36 439.867 602.44C436.454 600.477 433.787 597.768 431.867 594.312C429.947 590.856 428.987 586.909 428.987 582.472ZM507.113 605L497.961 591.24L489.897 605H477.481L491.881 582.152L477.161 560.072H489.897L498.921 573.64L506.857 560.072H519.273L505.001 582.728L519.849 605H507.113Z'
                fill='white'
            />
            <rect
                x='78'
                y='203'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint0_linear_90_87)'
            />
            <rect
                x='78'
                y='246'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint1_linear_90_87)'
            />
            <rect
                x='78'
                y='289'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint2_linear_90_87)'
            />
            <rect
                x='78'
                y='332'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint3_linear_90_87)'
            />
            <rect
                x='78'
                y='375'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint4_linear_90_87)'
            />
            <rect
                x='78'
                y='418'
                width='420'
                height='23'
                rx='11.5'
                fill='url(#paint5_linear_90_87)'
            />
            <rect
                x='78'
                y='461'
                width='198'
                height='23'
                rx='11.5'
                fill='url(#paint6_linear_90_87)'
            />
            <defs>
                <filter
                    id='filter0_d_90_87'
                    x='399'
                    y='21'
                    width='149'
                    height='149'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'
                >
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dx='-7' dy='4' />
                    <feGaussianBlur stdDeviation='9' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_90_87'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_90_87'
                        result='shape'
                    />
                </filter>
                <linearGradient
                    id='paint0_linear_90_87'
                    x1='288'
                    y1='203'
                    x2='288'
                    y2='226'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_90_87'
                    x1='288'
                    y1='246'
                    x2='288'
                    y2='269'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_90_87'
                    x1='288'
                    y1='289'
                    x2='288'
                    y2='312'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_90_87'
                    x1='288'
                    y1='332'
                    x2='288'
                    y2='355'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_90_87'
                    x1='288'
                    y1='375'
                    x2='288'
                    y2='398'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint5_linear_90_87'
                    x1='288'
                    y1='418'
                    x2='288'
                    y2='441'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
                <linearGradient
                    id='paint6_linear_90_87'
                    x1='177'
                    y1='461'
                    x2='177'
                    y2='484'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stop-color='#CBCBCB' />
                    <stop offset='0.942708' stop-color='#8A8A8A' />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default WordIconSVG;
